// markdownService.js
import MarkdownIt from "markdown-it";
import TurndownService from "turndown";

const markdownIt = new MarkdownIt();
const turndown = new TurndownService({
  headingStyle: "atx",
  codeBlockStyle: "fenced"
});

turndown.addRule("strikethrough", {
  filter: ["s", "strike", "del"],
  replacement: function (content) {
    return `~~${content}~~`;
  }
});

export function markdownToHtml(markdown) {
  return markdownIt.render(markdown);
}

export function htmlToMarkdown(html) {
  return turndown.turndown(html);
}
